import { combineReducers } from 'redux';
import stores from './storesReducer';
import activeStore from './editStoreReducer';
import login from './loginReducer';
import app from './appReducer';
import resetPassword from './resetPasswordReducer';

export default combineReducers({
  stores,
  activeStore,
  login,
  app,
  resetPassword
});



// WEBPACK FOOTER //
// ./src/store/reducer.js